import { render, staticRenderFns } from "./CoursewareDashboardTasks.vue?vue&type=template&id=ce05f8ac&"
import script from "./CoursewareDashboardTasks.vue?vue&type=script&lang=js&"
export * from "./CoursewareDashboardTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports